/**
 * Created by tmorone on 2/23/2016.
 */

var $ = require('jquery');
var Marionette = require('backbone.marionette');

module.exports = Marionette.LayoutView.extend({
    template: require('../templates/GamePage.html'),

    onRender: function() {
        // make sure scroll bar is hidden
        $('html').css('overflow','hidden');
    },

    onLocalStorage: function(e) {
        if(e.originalEvent.key == 'pack_name') {
            var swf = document.getElementById('swfContainer');
            if(swf) {
                swf.goToPack(e.originalEvent.newValue);
                localStorage.removeItem('pack_name');
            }
        }
    }
});
